<template>
  <input
    :value="value"
    :id="id"
    :placeholder="placeholder"
    :min="min"
    :max="max"
    type="number"
    autocomplete="off"
    oninput="validity.valid||(value='');"
    @input="$emit('input', $event.target.value)"
    @blur="$emit('blur', $event)"
    @focus="$emit('focus', $event)"
  />
</template>

<script>
/** Componente de input com máscara de moeda */

export default {
  name: 'InputCurrency',
  props: {
    /** Valor do input */
    value: {
      type: [Number, String],
      default: null
    },
    /** Id do input */
    id: {
      type: String,
      default: ''
    },
    /** Placeholder do campo vazio */
    placeholder: {
      type: String,
      default: ''
    },
    /** Valor mínimo */
    min: {
      type: [Number, String],
      default: 0
    },
    /** Valor máximo */
    max: {
      type: [Number, String],
      default: null
    }
  }
}
</script>
